

// @todo, make it part of parallax scenes
function keyboardNav() {

  var container = $('.main-nav');

  let focusable = 'a:visible, button:visible, :input:visible, [tabindex]:visible';
  //fixes jquery focus oddities between browsers
  $.fn.focusItem = function () {
    if (this.length && this[0].focus) {
      this[0].focus();
    }
    return this;
  };

  container.on('keydown', function (e) {
    //handle arrows and space
    handleOtherKeyboardNav(e);
  });

  container.find('a, button, :input, [tabindex]').on('focus', function (e) {
    //handle arrows and space
    handleCleanupOpenDropdowns(e);
  });

  function focusNextFocusable($ele) {
    let $focusable = $(focusable),
        i = $focusable.index($ele) + 1;
    if (i >= $focusable.length) i = 0;
    $focusable.eq(i).focusItem();
  }

  function focusPreviousFocusable($ele) {
    let $focusable = $(focusable),
      i = $focusable.index($ele) - 1;
    if (i <= 0) i = $focusable.length;
    $focusable.eq(i).focusItem();
  }

  function triggerClick($ele) {
    $ele.trigger('click');
  }

  function handleCleanupOpenDropdowns(e) {
    let $target = $(e.target);
    let $parent = $target.parents('.nav-item.display-menu');

    $('.nav-item').not($parent).each(function () {
      $(this).removeClass('display-menu').find('.dropdown-menu').hide();
    });
  }

  function handleOtherKeyboardNav(e) {
    let keyCode = e.keyCode,
      $target = $(e.target),
      stop = function (e) {
        e.stopPropagation();
        e.preventDefault();
      };

    //only listening for space or arrows on focusable items left, up, right, down
    if (!/^(32|37|38|39|40)$/.test(keyCode) || !$target.is(focusable)) {
      return;
    }
    switch (keyCode) {
      case 32: //space
        triggerClick($target);
        stop(e);
        break;
      case 37: //left
      case 38: // Up
        focusPreviousFocusable($target)
        stop(e);
        break;
      case 39: // Right
      case 40: // Down
        focusNextFocusable($target)
        stop(e);
        break;
    } //switch
  }
            /* end keyboard nav additions */

}

export default keyboardNav;
